import { render, staticRenderFns } from "./getSalesRankingInfoManage.vue?vue&type=template&id=270ac500&scoped=true"
import script from "./getSalesRankingInfoManage.vue?vue&type=script&lang=js"
export * from "./getSalesRankingInfoManage.vue?vue&type=script&lang=js"
import style0 from "./getSalesRankingInfoManage.vue?vue&type=style&index=0&id=270ac500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ac500",
  null
  
)

export default component.exports